export const BASE_URL = 'BASE_BFF_URL';
